//removeIf(production)
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
import ClaroluzEvents from "../../../../../infra/critical/claroluz-events";
//endRemoveIf(production)

class ClaroluzModalMini {
    private modal = document.querySelector('#claroluz-modal-loading-mini') as HTMLElement;

    constructor() {
        this.showEvent();
        this.hideEvent();
        this.closeClick();
    }

    private showEvent() {
        document.addEventListener('claroluz_loading_mini_show', () => {
            this.modal.classList.add('show');

            new ClaroluzEvents(appProperties(), 'modal', 'loading-mini', 'open');
        });
    }

    private hideEvent() {
        document.addEventListener('claroluz_loading_hide', () => {
            this.modal.classList.remove('show');

            new ClaroluzEvents(appProperties(), 'modal', 'loading-mini', 'close');
        });
    }

    private closeClick() {
        this.modal.addEventListener('click', () => {
            this.modal.classList.remove('show');

            new ClaroluzEventDispatch('claroluz_loading_show');
            new ClaroluzEvents(appProperties(), 'modal', 'loading-mini', 'close');
        });
    }
}

//removeIf(production)
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}

export default ClaroluzModalMini;
//endRemoveIf(production)
